import { api, withFallback } from "./api/client";
import { mockCompanyProfile } from "@/lib/intelligence/company-profile.mock";
import type { CompanyProfile } from "@/types";

export const companyProfileService = {
  /** `null` significa que el tenant aún no completó su ficha de empresa (estado válido, no error). */
  get: () =>
    withFallback<CompanyProfile | null>(
      async () => (await api.get<CompanyProfile | null>("/company-profile")).data,
      () => mockCompanyProfile,
    ),

  update: (patch: Partial<CompanyProfile>) =>
    withFallback<CompanyProfile>(
      async () => (await api.patch<CompanyProfile>("/company-profile", patch)).data,
      () => ({ ...mockCompanyProfile, ...patch }),
    ),

  /** Autocomplete de categorías UNSPSC reales (ver categoriaUnspsc en Licitacion). Sin match offline: mock devuelve vacío. */
  searchCategoriasUnspsc: (q: string) =>
    withFallback<{ nombre: string; frecuencia: number }[]>(
      async () =>
        (
          await api.get<{ nombre: string; frecuencia: number }[]>("/company-profile/categorias-unspsc", {
            params: { q },
          })
        ).data,
      () => [],
    ),

  /** Autocomplete de regiones reales (Licitacion.region). Sin match offline: mock devuelve vacío. */
  searchRegiones: (q: string) =>
    withFallback<{ nombre: string; frecuencia: number }[]>(
      async () =>
        (
          await api.get<{ nombre: string; frecuencia: number }[]>("/company-profile/regiones-mp", {
            params: { q },
          })
        ).data,
      () => [],
    ),
};
